import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { queryOrders } from "../endpoints/order";
import { useBackendCurrency, useBackendLang } from "../lang-context";
import type { OrderListUrlInput } from "../path-adapter";
import type { OrderListResult } from "../types/order";

/**
 * `GET /order/listV2` — paged orders, filtered by status / keyword.
 * Auth required; pass null token to disable.
 */
export function useOrders(authToken: string | null, input: OrderListUrlInput = {}) {
  const lang = useBackendLang();
  const currency = useBackendCurrency();
  return useQuery<OrderListResult>({
    queryKey: ["orders", "list", input, lang, currency],
    enabled: !!authToken,
    queryFn: () => {
      if (!authToken) throw new Error("NO_TOKEN");
      return queryOrders({ baseUrl: API_BASE_URL }, authToken, input, { lang, currency });
    },
    staleTime: 30_000,
  });
}
